import CurrentPostedPriceService from '@/classes-internal/currentPostedPrice/CurrentPostedPriceService'
import PriceHistoryService from '@/classes-internal/priceHistory/PriceHistoryService'
import ProductTargetPriceService from '@/classes-internal/productTargetPrice/ProductTargetPriceService'
import RealizedDemandService from '@/classes-internal/realizedDemand/RealizedDemandService'

const state = () => ({
  selectedDate: new Date(),
  selectedDefinitions: [],
  realizedDemand: {},
  currentPostedPrices: [],
  currentSelectedPrices: [],
  currentPriceHistory: [],
  productTargetPrices: [],
  currentPostedPricesService: new CurrentPostedPriceService(),
  priceHistoryService: new PriceHistoryService(),
  productTargetPriceService: new ProductTargetPriceService(),
  realizedDemandService: new RealizedDemandService(),
})

// getters
const getters = {
  selectedDefinitions: (state) => {
    return state.selectedDefinitions
  },
  getCurrentPostedPrices: (state) => {
    return state.currentPostedPrices
  },
  getCurrentSelectedPrices: (state) => {
    return state.currentSelectedPrices
  },
  currentPriceHistory: (state) => {
    return state.currentPriceHistory
  },
  selectedDate: (state) => {
    return state.selectedDate
  },
  productTargetPrices: (state) => {
    return state.productTargetPrices
  },
  realizedDemand: (state) => {
    return state.realizedDemand
  },
}

// actions
const actions = {
  async loadCurrentPostedPrices(
    { commit, state },
    { from, to, postedProductDefinitionIds, selectedProductDefinitionIds }
  ) {
    const prices = await state.currentPostedPricesService.fetchBetween(
      from,
      to,
      selectedProductDefinitionIds
    )
    commit(
      'setCurrentPostedPrices',
      prices.filter((price) =>
        postedProductDefinitionIds.includes(price.productDefinitionId)
      )
    )
    commit('setCurrentSelectedPrices', prices)
  },
  async loadPriceHistory({ commit, state }, { date }) {
    const productDefIds = state.selectedDefinitions.map(
      (selected) => selected.item.id
    )
    const history = await state.priceHistoryService.fetchHistory(
      date,
      productDefIds
    )
    commit('setCurrentPriceHistory', history)
  },
  async fetchProductTargetPrices(
    { commit, state },
    { from, to, productDefIds }
  ) {
    const targetPrices = await state.productTargetPriceService.fetchBetween(
      from,
      to,
      productDefIds
    )
    commit('setProductTargetPrices', targetPrices)
  },
  async realizedDemands({ commit, state }, { from, to, productDefIds }) {
    const realizedDemand = await state.realizedDemandService.fetchBetween(
      from,
      to,
      productDefIds
    )
    commit('setRealizedDemand', realizedDemand)
  },
}

// mutations
const mutations = {
  setSelectedDefinitions(state, selectedProductDefinitions) {
    state.selectedDefinitions = selectedProductDefinitions
  },
  addSelectedDefinition(state, selectedProductDefinitions) {
    state.selectedDefinitions.push(selectedProductDefinitions)
  },
  removeSelectedDefinition(state, index) {
    state.selectedDefinitions.splice(index, 1)
  },
  setCurrentPostedPrices(state, currentPostedPrices) {
    state.currentPostedPrices = currentPostedPrices
  },
  setCurrentSelectedPrices(state, currentSelectedPrices) {
    state.currentSelectedPrices = currentSelectedPrices
  },
  setCurrentPriceHistory(state, history) {
    state.currentPriceHistory = history
  },
  setSelectedDate(state, date) {
    state.selectedDate = date
  },
  setProductTargetPrices(state, targetPrices) {
    state.productTargetPrices = targetPrices
  },
  setRealizedDemand(state, demands) {
    state.realizedDemand = demands
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
